<template>
    <div  class="collegeVideo">

        <div class="videoSmallBox position-relative commonBackground">
            <div id='J_prismPlayer' class='prism-player'
                 style="visibility: visible;width:890px;height:500px;"
                 v-show="playAuth!==null&&!loadingPlayAuth">
            </div>
             <empty v-show="!loadingPlayAuth&&playAuth===null" style="padding-top: 60px;"   content="暂无视频">
             </empty>
             <loading :show="loadingPlayAuth" width="890px"></loading>
        </div>
    </div>
</template>
<script>
    import {uniPropagandaVideo} from "../../../../../config";
    import {EventBus} from "../../../../../assets/static/global/event-bus";
    export default {
        name: "collegePublicityVideo",
        props:{
            univerSityId:String
        },
        data(){
          return{
              videoData:'',
              videoId:'',
              playAuth:null,
              loadingPlayAuth:false
          }
        },
        mounted(){
            EventBus.$on('publicityVideo',(res)=>{
                if(res){
                   this.lookAboutVideo('zhi');
                }else{
                    this.lookAboutVideo();
                }
            })
        },
        methods:{

            //查出相关视频
            async lookAboutVideo(val){

                document.getElementById('J_prismPlayer').remove();
                let zhi=document.createElement('div');
                zhi.setAttribute('id','J_prismPlayer');
                document.querySelector('.videoSmallBox').appendChild(zhi);
                if(val){
                    return false;
                }
                this.loadingPlayAuth=true;
                let result=await uniPropagandaVideo(this.univerSityId);
                if(result.status){
                    this.loadingPlayAuth=false;
                    this.videoData=result.data;
                    this.playAuth=result.data.playAuth;
                    this.videoId=result.data.videoId;
                    if(this.playAuth!==null){
                        this.commonPlayVideo();
                    }
                }else{
                    this.loadingPlayAuth=false;
                }
            },
            commonPlayVideo(){
                var player = new Aliplayer({
                        id: "J_prismPlayer",     // 容器id
                        vid: this.videoId,      //媒体转码服务的媒体Id
                        playauth: this.playAuth,//播放鉴权 [playauth参照](https://help.aliyun.com/document_detail/52833.html?spm=5176.doc51236.6.627.5gm5gf)
                        width: "890px",
                        height: "500px",
                        useH5Prism: true,
                        controlBarVisibility: "hover",
                        playsinline: true,
                        language:'zh-cn',
                        definition: 'FD,LD,SD',
                        defaultDefinition: 'SD'
                    });
                player.autoplay = false;
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import 'https://g.alicdn.com/de/prismplayer/2.7.2/skins/default/aliplayer-min.css';
    .collegeVideo{
        -webkit-box-flex: 1;
        -ms-flex-positive: 1;
        flex-grow: 1;
        border-left: 1px solid #d6d6d6;
        border-right: 1px solid #d6d6d6;
        border-bottom: 1px solid #d6d6d6;

        .videoSmallBox{

            min-height: 500px;
            margin: 30px;

        }
    }
</style>